{
  "title": "Invite a friend",
  "subtitle": "Bring someone with you. You both get 7 days of Plus",
  "yourCode": "Your invite code",
  "copyCode": "Copy code",
  "copied": "Copied",
  "share": "Invite a friend",
  "shareMessage": "Join me on Opncue — use my code {{code}} and we both get 7 days of Plus. {{url}}",
  "howItWorks": "How it works",
  "step1": "Share your code or link with a friend.",
  "step2": "They join, finish setting up, and send or get a Cue.",
  "step3": "They stay active for a week — then you both get 7 days of Plus.",
  "capNote": "The 7-day Plus offer can only be earned once per month, on a free plan.",
  "capReached": "You've earned your Plus reward this month. Keep inviting — more next month.",
  "loadError": "Couldn't load your invites. Pull to try again.",
  "rewardActive": "Your Plus reward is active until {{date}}.",
  "haveCode": "Have an invite code?",
  "codePlaceholder": "Enter code (optional)",
  "apply": "Apply",
  "codeApplied": "Invite code applied",
  "codeInvalid": "That code isn't valid.",
  "codeError": "Couldn't apply that code. Try again.",
  "shareWithCue": "Invite & ask to talk",
  "shareWithCueMessage": "Join me on Opncue. I'll send you a Cue and once we're connected, we can see when either of us is open to chat. {{url}}",
  "shareWithCueHint": "Send them an invite and a Cue asking to connect. Each link expires in 7 days.",
  "shareFailed": "Could not create that link. Try again.",
  "landingTitle": "{{name}} invited you",
  "landingCueBody": "They would like to start a conversation.",
  "landingPlainBody": "They shared Opncue with you.",
  "landingAccept": "Accept invite",
  "landingExpired": "This invite link has expired.",
  "landingUsed": "This invite link has already been used.",
  "landingOwn": "This is your own invite link.",
  "landingMissing": "This invite link is not valid.",
  "landingBrowse": "Look around instead",
  "landingCueArrived": "Their Cue is in your requests.",
  "landingAlreadyTalking": "You are already connected. Click Okay to open your conversation.",
  "shareShort": "Share",
  "shareWithCueShort": "Invite & send a Cue",
  "landingInvitedGeneric": "You have an invite to Opncue",
  "landingMobileWeb": "Opncue is built for your phone. Get the app to accept this invite.",
  "landingGetApp": "Get the app",
  "landingAlreadyConnected": "You are already connected."
}
